export default "__VITE_ASSET__kp3hq3eX__"